import React from "react";
import { logoUrl } from "@/lib/api";

const GRADS = [
  "linear-gradient(135deg,#7CF24E,#1EC62E)",
  "linear-gradient(135deg,#FF007A,#FFB800)",
  "linear-gradient(135deg,#3B82F6,#00E5FF)",
  "linear-gradient(135deg,#9b59b6,#FF007A)",
  "linear-gradient(135deg,#1EC62E,#FFB800)",
];

export default function CoinLogo({ coin, size = 48, className = "" }) {
  const url = logoUrl(coin);
  const sym = (coin?.symbol || "?").slice(0, 3);
  const grad = GRADS[(coin?.symbol || "x").charCodeAt(0) % GRADS.length];
  if (url) {
    return (
      <img
        src={url}
        alt={coin?.name}
        style={{ width: size, height: size }}
        className={`rounded-lg object-cover border border-white/10 ${className}`}
      />
    );
  }
  return (
    <div
      style={{ width: size, height: size, background: grad, fontSize: size * 0.34 }}
      className={`rounded-lg flex items-center justify-center font-display font-extrabold text-black shrink-0 ${className}`}
    >
      {sym}
    </div>
  );
}
